<template>
  <div v-if="!hide">
    <div class="img-bkg">
      <div class="img-bkg-container text-light">
        <div>
          <h5 class="font-weight-bolder mb-0">Bem-vindo ao LeCard</h5>
        </div>
      </div>
    </div>
    <div class="card p-3 mt-2" v-for="a in informes">
      <div class="mb-1">
        <span class="badge badge-success mr-1" v-if="a.tipo === '1'">Novidades</span>
        <span class="badge badge-warning mr-1" v-if="a.tipo === '2'">Avisos</span>
        {{a.data_informe}}
      </div>
      <h5 class="font-weight-bolder mb-0">{{ a.titulo }}</h5>
      <p class="mb-0" v-if="a.subtitulo">{{ a.subtitulo }}</p>
      <img :src="a.img_informe" class="img-bkg mb-1" style="margin-top: 12px" v-if="a.img_informe">
      <div class="mt-2" v-html="a.texto_informe"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MsgHome',
  props: ['hide'],
  data() {
    return {
      desativados: 0
    }
  },

  methods: {
    getInformes() {
      this.load = true;

      this.$http.get('informes?status=1')
        .then(res => {
          this.load = false;
          this.$store.state.informes = (res.data || []);
        }).then(() => {}, () => {});
    }
  },

  mounted() {
    if (!this.informes.length) {
      this.getInformes();
    }
  },

  computed: {
    informes() {
      return this.$store.state.informes;
    }
  }
}
</script>
<style scoped>
  .img-bkg {
    background-image: url("../../assets/bg-home.jpeg");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    position: relative;
    height: 120px;
    border-radius: 8px;
    overflow: hidden;
  }
  .img-bkg-container {
    background-color: rgba(0,0,0,0.5);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 22px 18px;
    text-align: center;
  }
</style>
